import { useJoinToScreenRoom } from './useJoinToScreenRoom';

export const ScreenWrapper = ({ title, children }) => {
  useJoinToScreenRoom({ name: title });
  return children;
};
